import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelText as _vModelText, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "Referral_Source",
  class: "row p-4 pb-0",
  slot: "content"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Referral Information"),
  /*#__PURE__*/_createElementVNode("p", null, " Use the filters below to narrow down physicians by city and/or state. To search for a physician, enter the physician's name or NPI in the respective search field. ")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "form-group col-12 d-flex flex-column" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Filters", -1 /* HOISTED */)
const _hoisted_5 = { class: "col-12 flex-row py-2 px-3 row g-0 mb-2" }
const _hoisted_6 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " City ", -1 /* HOISTED */)
const _hoisted_8 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " State ", -1 /* HOISTED */)
const _hoisted_10 = { class: "form-group col-12 d-flex flex-column" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Search", -1 /* HOISTED */)
const _hoisted_12 = { class: "col-12 flex-row px-3 row g-0 mb-2 align-items-center" }
const _hoisted_13 = { class: "form-group card p-2 d-flex col-12 col-lg-6 pe-lg-3 flex-row justify-content-between" }
const _hoisted_14 = { class: "form-group col-lg-6 ps-2" }
const _hoisted_15 = { for: "referral-source" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Referring Physician ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_18 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "form-check d-flex align-items-center pb-1" }
const _hoisted_22 = ["id"]
const _hoisted_23 = ["for"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Certifying Physician", -1 /* HOISTED */)
const _hoisted_25 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "form-group col-12 col-lg-1 text-center" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "OR")
], -1 /* HOISTED */)
const _hoisted_29 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " NPI ", -1 /* HOISTED */)
const _hoisted_31 = { class: "form-group col-12 d-flex flex-column" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Face-to-Face Evaluation Information", -1 /* HOISTED */)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_34 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "form-group p-2 col-12 col-lg-6 pe-lg-3 flex-row" }
const _hoisted_38 = { class: "col-12 col-lg-10 d-flex g-0" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  class: "px-2",
  for: "evaluationna"
}, "NA ", -1 /* HOISTED */)
const _hoisted_40 = { class: "col-12 col-lg-10 d-flex g-0" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  class: "px-2",
  for: "evaluationdate"
}, " Date of Face-to-Face Visit ", -1 /* HOISTED */)
const _hoisted_42 = { class: "col-12 col-lg-10 d-flex g-0" }
const _hoisted_43 = {
  key: 0,
  class: "form-group offset-lg-1"
}
const _hoisted_44 = { class: "input-group date datepickerInput" }
const _hoisted_45 = ["value"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_47 = { class: "col-12 col-lg-10 d-flex g-0" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", {
  class: "px-2",
  for: "evaluationwithindays"
}, "Face-to-Face to be completed within 30 days ", -1 /* HOISTED */)
const _hoisted_49 = { class: "form-group col-12 d-flex row" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Certifying Physician Information"),
  /*#__PURE__*/_createElementVNode("p", null, " Use the filters below to narrow down physicians by city and/or state. To search for a physician, enter the physician's name or NPI in the respective search field. ")
], -1 /* HOISTED */)
const _hoisted_51 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_52 = { class: "form-check custom-checkbox pb-1" }
const _hoisted_53 = ["id"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "me-1 text-secondary" }, "Hide Search Parameters", -1 /* HOISTED */)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = { class: "col-12 d-flex flex-column" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Filters", -1 /* HOISTED */)
const _hoisted_58 = { class: "col-12 flex-row py-2 px-3 row g-0 mb-2" }
const _hoisted_59 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " City ", -1 /* HOISTED */)
const _hoisted_61 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " State ", -1 /* HOISTED */)
const _hoisted_63 = { class: "form-group col-12 d-flex flex-column" }
const _hoisted_64 = {
  key: 0,
  class: "me-2"
}
const _hoisted_65 = { class: "form-group card p-2 d-flex col-12 pe-lg-3 col-lg-8 flex-row justify-content-between" }
const _hoisted_66 = { class: "form-group col-lg-8 ps-2" }
const _hoisted_67 = { for: "referral-source" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Certifying Physician ")
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_70 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = { class: "form-check d-flex align-items-center custom-checkbox pb-1" }
const _hoisted_74 = ["id"]
const _hoisted_75 = ["for"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, " Attending Physician ", -1 /* HOISTED */)
const _hoisted_77 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "form-group col-12 col-lg-1 text-center" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "OR")
], -1 /* HOISTED */)
const _hoisted_81 = { class: "form-group col-12 col-lg-3 pe-lg-3" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " NPI ", -1 /* HOISTED */)
const _hoisted_83 = {
  key: 1,
  class: "form-group col-12 col-lg-4 pe-lg-3"
}
const _hoisted_84 = { class: "form-check custom-checkbox pb-1" }
const _hoisted_85 = ["id"]
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "me-1 text-secondary" }, "View More Search Parameters ", -1 /* HOISTED */)
const _hoisted_87 = [
  _hoisted_86
]
const _hoisted_88 = { class: "col-12 row px-2 g-0" }
const _hoisted_89 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", { for: "admission-source-name" }, [
  /*#__PURE__*/_createTextVNode(" Admission Source "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "--Select Option--", -1 /* HOISTED */)
const _hoisted_92 = ["value"]
const _hoisted_93 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " Name of Referral Source", -1 /* HOISTED */)
const _hoisted_95 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("label", { for: "referral-date" }, [
  /*#__PURE__*/_createTextVNode(" Referral Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_97 = { class: "input-group date datepickerInput" }
const _hoisted_98 = ["value"]
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_100 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("label", { for: "community-liaison" }, " Community Liaison ", -1 /* HOISTED */)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("option", { value: '00000000-0000-0000-0000-000000000000' }, "--Select Option--", -1 /* HOISTED */)
const _hoisted_103 = ["value"]
const _hoisted_104 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("label", { for: "internal-referral-source-name" }, " Internal Referral Source ", -1 /* HOISTED */)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("option", { value: '00000000-0000-0000-0000-000000000000' }, "--Select Option--", -1 /* HOISTED */)
const _hoisted_107 = ["value"]
const _hoisted_108 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Facility Referral Source")
], -1 /* HOISTED */)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("option", { value: '00000000-0000-0000-0000-000000000000' }, "--Select Option--", -1 /* HOISTED */)
const _hoisted_111 = ["value"]
const _hoisted_112 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_113 = { for: "type-of-inpatient-code" }
const _hoisted_114 = /*#__PURE__*/_createTextVNode("Type of Inpatient Admission/Visit Code ")
const _hoisted_115 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_116 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_117 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_118 = [
  _hoisted_117
]
const _hoisted_119 = /*#__PURE__*/_createElementVNode("option", { value: null }, "--Select Option--", -1 /* HOISTED */)
const _hoisted_120 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Referral Information",
    type: "his-section",
    "full-height": false,
    "application-id": Number(_ctx.application)
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("section", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getReferringPhysicianListItem,
                value: _ctx.referringPhysicianFilters.city,
                onValueChanged: _ctx.referringPhysicianFiltersCity,
                "results-limit": 1,
                "init-value": _ctx.referringPhysicianFilters.city,
                itemName: "city",
                placeholder: "Select City"
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getReferringPhysicianListItem,
                value: _ctx.referringPhysicianFilters.state,
                onValueChanged: _ctx.referringPhysicianFiltersState,
                "init-value": _ctx.referringPhysicianFilters.state,
                "results-limit": 2,
                itemName: "state",
                placeholder: "Select State"
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("section", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, [
                  _hoisted_16,
                  _hoisted_17,
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_18, _hoisted_20)), [
                    [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.refPhysicianTooltip) }]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_TypeaheadInput, {
                    getData: _ctx.getReferringPhysicianList,
                    value: _ctx.referringPhysicianName,
                    onValueChanged: _ctx.referringPhysicianNameChange,
                    placeholder: "Search By Name",
                    onBlurredInput: _ctx.v$.referral.ReferralInformation.ReferrerPhysician.$touch,
                    isError: 
                                            _ctx.v$.referral.ReferralInformation.ReferrerPhysician.$error ||
                                            _ctx.errors.ReferralInformation.includes('ReferrerPhysician')
                                        
                  }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "onBlurredInput", "isError"])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: `signing-plan-of-care-${_ctx.refName}`,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.ReferralInformation.IsSigningPlanOfCare) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.signingPOCChanged()))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_22), [
                  [_vModelCheckbox, _ctx.referral.ReferralInformation.IsSigningPlanOfCare]
                ]),
                _createElementVNode("label", {
                  class: "form-check-label flex-grow-0",
                  for: `signing-plan-of-care-${_ctx.refName}`
                }, [
                  _hoisted_24,
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_25, _hoisted_27)), [
                    [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.signingPOCTooltip) }]
                  ])
                ], 8 /* PROPS */, _hoisted_23)
              ])
            ]),
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getReferringPhysicianListItem,
                value: _ctx.referringPhysicianFilters.npi,
                onValueChanged: _ctx.referringPhysicianFiltersNpiChange,
                "results-limit": 3,
                itemName: "npi",
                "key-updated": _ctx.npiChanged('referring'),
                placeholder: "Search By NPI"
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "key-updated"])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_31, [
          _createElementVNode("div", {
            class: _normalizeClass(` ${
                            _ctx.v$.referral.ReferralInformation.DateOfFaceToFaceVisit.$error ||
                            _ctx.errors.ReferralInformation.includes('DateOfFaceToFaceVisit')
                                ? 'border border-warning rounded p-2'
                                : ''
                        }`)
          }, [
            _hoisted_32,
            _hoisted_33,
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_34, _hoisted_36)), [
              [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.faceToFaceTooltip) }]
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check custom-radio pb-1",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referral.ReferralInformation.FaceToFaceInformationNA) = $event)),
                  name: "face-to-face-evaluation",
                  "au-target-id": "791",
                  id: "evaluationna"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.referral.ReferralInformation.FaceToFaceInformationNA]
                ]),
                _hoisted_39
              ]),
              _createElementVNode("div", _hoisted_40, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check custom-radio pb-1",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.faceToFaceEvaluation) = $event)),
                  name: "face-to-face-evaluation",
                  "au-target-id": "791",
                  id: "evaluationdate"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.faceToFaceEvaluation]
                ]),
                _hoisted_41
              ]),
              _createElementVNode("div", _hoisted_42, [
                (_ctx.faceToFaceEvaluation)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("input", {
                              type: "text",
                              name: "DateOfFaceToFaceVisit",
                              class: "form-control",
                              placeholder: "MM/DD/YYYY",
                              value: 
                                                    _ctx.formatDateInput(_ctx.referral.ReferralInformation.DateOfFaceToFaceVisit)
                                                ,
                              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args))),
                              autocomplete: "off"
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_45),
                            _hoisted_46
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check custom-radio pb-1",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referral.ReferralInformation.FaceToFaceToBeCompletedWithin30Days) = $event)),
                  name: "face-to-face-evaluation",
                  "au-target-id": "791",
                  id: "evaluationwithindays"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.referral.ReferralInformation.FaceToFaceToBeCompletedWithin30Days]
                ]),
                _hoisted_48
              ])
            ])
          ], 2 /* CLASS */)
        ]),
        _createElementVNode("section", _hoisted_49, [
          (_ctx.showCertifyPhysicianFilters)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("button", {
                      class: "card px-2 py-2 cursor-pointer",
                      id: `certifying-physician-${_ctx.refName}`,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showCertifyPhysicianFilters = !_ctx.showCertifyPhysicianFilters))
                    }, _hoisted_55, 8 /* PROPS */, _hoisted_53)
                  ])
                ]),
                _createElementVNode("section", _hoisted_56, [
                  _hoisted_57,
                  _createElementVNode("section", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _hoisted_60,
                      _createVNode(_component_TypeaheadInput, {
                        getData: _ctx.getCertifyingPhysicianListItem,
                        value: _ctx.certifyingPhysicianFilters.city,
                        onValueChanged: _ctx.certifyingPhysicianFiltersCityChange,
                        "init-value": _ctx.certifyingPhysicianFilters.city,
                        "results-limit": 1,
                        itemName: "city",
                        placeholder: "Select City"
                      }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _createVNode(_component_TypeaheadInput, {
                        getData: _ctx.getCertifyingPhysicianListItem,
                        value: _ctx.certifyingPhysicianFilters.state,
                        onValueChanged: _ctx.certifyingPhysicianFiltersStateChange,
                        "init-value": _ctx.certifyingPhysicianFilters.state,
                        "results-limit": 2,
                        itemName: "state",
                        placeholder: "Select State"
                      }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
                    ])
                  ])
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("section", _hoisted_63, [
            (_ctx.showCertifyPhysicianFilters)
              ? (_openBlock(), _createElementBlock("b", _hoisted_64, "Search"))
              : _createCommentVNode("v-if", true),
            _createElementVNode("section", {
              class: _normalizeClass(["flex-row row g-0 mb-2 align-items-center", _ctx.showCertifyPhysicianFilters && 'col-12'])
            }, [
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("label", _hoisted_67, [
                    _hoisted_68,
                    _hoisted_69,
                    _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_70, _hoisted_72)), [
                      [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.certifyingPhysicianTooltip) }]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.getCertifyingPhysicianList,
                      value: _ctx.referral.ReferralInformation.CertifyingPhysicianName,
                      onValueChanged: _ctx.certifyingPhysicianNameChange,
                      placeholder: "Search By Name",
                      onBlurredInput: 
                                                _ctx.v$.referral.ReferralInformation.CertifyingPhysician.$touch
                                            ,
                      isError: 
                                                _ctx.v$.referral.ReferralInformation.CertifyingPhysician.$error ||
                                                _ctx.errors.ReferralInformation.includes('CertifyingPhysician')
                                            
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "onBlurredInput", "isError"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    id: `referral-attending-physician-${_ctx.refName}`,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.referral.ReferralInformation.IsPrimaryCarePhysician) = $event))
                  }, null, 8 /* PROPS */, _hoisted_74), [
                    [_vModelCheckbox, _ctx.referral.ReferralInformation.IsPrimaryCarePhysician]
                  ]),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: `referral-attending-physician-${_ctx.refName}`
                  }, [
                    _hoisted_76,
                    _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_77, _hoisted_79)), [
                      [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.attendingPhysicianTooltip) }]
                    ])
                  ], 8 /* PROPS */, _hoisted_75)
                ])
              ]),
              (_ctx.showCertifyPhysicianFilters)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_80,
                    _createElementVNode("div", _hoisted_81, [
                      _hoisted_82,
                      _createVNode(_component_TypeaheadInput, {
                        getData: _ctx.getCertifyingPhysicianListItem,
                        value: _ctx.certifyingPhysicianFilters.npi,
                        onValueChanged: _ctx.certifyingPhysicianFiltersNpiChange,
                        itemName: "npi",
                        placeholder: "Search By NPI",
                        "results-limit": 3,
                        "key-updated": _ctx.npiChanged('certifying')
                      }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "key-updated"])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              (!_ctx.showCertifyPhysicianFilters)
                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                    _createElementVNode("div", _hoisted_84, [
                      _createElementVNode("button", {
                        class: "card px-2 py-2 cursor-pointer",
                        id: `certifying-physician-${_ctx.refName}`,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showCertifyPhysicianFilters = !_ctx.showCertifyPhysicianFilters))
                      }, _hoisted_87, 8 /* PROPS */, _hoisted_85)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)
          ]),
          _createElementVNode("section", _hoisted_88, [
            _createElementVNode("div", _hoisted_89, [
              _hoisted_90,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.referral.ReferralInformation.AdmissionSource) = $event)),
                class: _normalizeClass(`form-select ${
                                    _ctx.v$.referral.ReferralInformation.AdmissionSource.$error ||
                                    _ctx.errors.ReferralInformation.includes('AdmissionSource')
                                        ? 'border border-warning rounded p-2'
                                        : ''
                                }`),
                onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.ReferralInformation.AdmissionSource.$touch && _ctx.v$.referral.ReferralInformation.AdmissionSource.$touch(...args))),
                onChange: _cache[11] || (_cache[11] = (e)=>_ctx.handleAllInputChange('AdmissionSource',e.target.value))
              }, [
                _hoisted_91,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.admissionSource, (admSource, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: admSource.value
                  }, _toDisplayString(admSource.text), 9 /* TEXT, PROPS */, _hoisted_92))
                }), 128 /* KEYED_FRAGMENT */))
              ], 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelSelect, _ctx.referral.ReferralInformation.AdmissionSource]
              ])
            ]),
            _createElementVNode("div", _hoisted_93, [
              _hoisted_94,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                type: "text",
                placeholder: "Enter Name of Referral Source",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.referral.ReferralInformation.ReferralSourceName) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.referral.ReferralInformation.ReferralSourceName]
              ])
            ]),
            _createElementVNode("div", _hoisted_95, [
              _hoisted_96,
              _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_97, [
                    _createElementVNode("input", {
                      type: "text",
                      name: "referral-date-edit",
                      class: _normalizeClass(`form-control ${
                                            _ctx.v$.referral.ReferralInformation.ReferralDate.$error ||
                                            _ctx.errors.ReferralInformation.includes('ReferralDate')
                                                ? 'border border-warning'
                                                : ''
                                        }`),
                      placeholder: "MM/DD/YYYY",
                      value: _ctx.formatDateInput(_ctx.referral.ReferralInformation.ReferralDate),
                      onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.ReferralInformation.ReferralDate.$touch && _ctx.v$.referral.ReferralInformation.ReferralDate.$touch(...args))),
                      onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args))),
                      autocomplete: "off"
                    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_98),
                    _hoisted_99
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["getDate"])
            ]),
            _createElementVNode("div", _hoisted_100, [
              _hoisted_101,
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.referral.ReferralInformation.CommunityLiaison) = $event))
              }, [
                _hoisted_102,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.communityLiaison, (cmtLiaison, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: cmtLiaison.value
                  }, _toDisplayString(cmtLiaison.text), 9 /* TEXT, PROPS */, _hoisted_103))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.referral.ReferralInformation.CommunityLiaison]
              ])
            ]),
            _createElementVNode("div", _hoisted_104, [
              _hoisted_105,
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.referral.ReferralInformation.InternalReferral) = $event))
              }, [
                _hoisted_106,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.internalReferral, (intrlRef, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: intrlRef.value
                  }, _toDisplayString(intrlRef.text), 9 /* TEXT, PROPS */, _hoisted_107))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.referral.ReferralInformation.InternalReferral]
              ])
            ]),
            _createElementVNode("div", _hoisted_108, [
              _hoisted_109,
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.referral.ReferralInformation.FacilitySource) = $event))
              }, [
                _hoisted_110,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.facilitySource, (rflOption, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: rflOption.value
                  }, _toDisplayString(rflOption.text), 9 /* TEXT, PROPS */, _hoisted_111))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.referral.ReferralInformation.FacilitySource]
              ])
            ]),
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("label", _hoisted_113, [
                _hoisted_114,
                _hoisted_115,
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_116, _hoisted_118)), [
                  [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.inpatientCodeTooltip) }]
                ])
              ]),
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(`form-control ${
                                    _ctx.v$.referral.Insurance.AdditionalBillingInfo.AdmissionType.$error ||
                                    _ctx.errors.AdditionalBillingInfo.includes('AdmissionType')
                                        ? 'border border-warning'
                                        : ''
                                }`),
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.AdmissionType) = $event)),
                onBlur: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.AdditionalBillingInfo.AdmissionType.$touch && _ctx.v$.referral.Insurance.AdditionalBillingInfo.AdmissionType.$touch(...args))),
                onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleBillingInfo('AdmissionType')))
              }, [
                _hoisted_119,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions.admissionType, (admType, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: admType.value
                  }, _toDisplayString(admType.text), 9 /* TEXT, PROPS */, _hoisted_120))
                }), 128 /* KEYED_FRAGMENT */))
              ], 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelSelect, _ctx.referral.Insurance.AdditionalBillingInfo.AdmissionType]
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}